import { render, staticRenderFns } from "./CreateAccount.vue?vue&type=template&id=2932a582&scoped=true&"
import script from "./CreateAccount.vue?vue&type=script&lang=js&"
export * from "./CreateAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2932a582",
  null
  
)

export default component.exports